module.exports = __webpack_public_path__ + "img/uploadImage.0b139312.jpg";